<template>
  <div class="file-view">
    <van-nav-bar class="file-header preview-header preview-header-bgcolor">
      <i slot="left" class="iconfont icon-back" @click="handleClose"/>
      <template slot="title">
        <span>文件上传</span>
      </template>
    </van-nav-bar>
    <div class="upload-content" v-if="items.length > 0">
      <div class="file-list-container">
        <div class="file-list" @scroll.passive="onScroll">
          <li v-for="(item) of items" :key="`${item.id}`">
            <upload-item
              v-if="item.is_upload"
              :item="item"
              :cancelWithMercy="true"
              @item-uploaded="onItemUploaded"
              @item-delete="onItemDeleted"
              @item-error="onItemError"
              @item-reUpload="onItemReUpload"
            />
            <file-item
              v-else
              :item="item"
              :hideAction="true"
              :scenario="scenario"
              :disableClickStyle="false"
            />
          </li>
        </div>
      </div>
      <div class="bottom-actions">
        <svg-icon cls="state-icon" v-if="inUploading" icon="state-upload"/>
        <svg-icon cls="state-icon" v-if="finishWithErrors" icon="state-error"/>
        <svg-icon cls="state-icon" v-if="finishWithSuccess" icon="state-success"/>
        <div class="bottom-prompt" v-if="inUploading">{{progressPrompt}}</div>
        <div class="bottom-prompt" v-if="finishWithErrors" @click="retryAllErrors">
          {{errorPrompt}}
          <span style="color: #6ca2ff;">点击重试</span>
        </div>
        <div class="bottom-prompt" v-if="finishWithSuccess" @click="handleClose">
          上传成功，
          <span style="color: #6ca2ff;">{{backRightNowPrompt}}</span>
        </div>
      </div>
    </div>
    <div class="select-view" v-else @click="selectLocalFiles">
      <i class="iconfont icon-mobile-upload"/>
      <div>从手机上传</div>
      <div class="upload-max-count">{{maxCountPrompt}}</div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import { i18n } from '@/utils/i18n'
import UploadItem from './UploadItem'
import { Dialog } from 'vant'
import FileItem from './FileItem'
import {openPlatformCallback, guid} from '@/utils/common'
import {triggerUploadFile, normalizeUploadFile, normalizeUploadFile4back} from '@/utils/fileUtils'
export default {
  name: 'OpenPlatformUploadFiles',
  i18n,
  components: {
    FileItem,
    UploadItem
  },
  created () {
    this.uploadTarget = `folder_${this.$route.query.folderId || '0'}`
    this.uploadFileMax = parseInt(config.openConfig.uploadFileMax) || 10 // default：10
  },
  data () {
    return {
      items: [],
      uploadFiles: {},
      completedCount: 0,
      failedCount: 0,
      scenario: 'open_view',
      uploadFileMax: 1,
      backTime: 3,
      closeTimer: null
    }
  },
  computed: {
    progressPrompt () {
      return `上传中(${this.completedCount}/${this.items.length})，请不要返回`
    },
    errorPrompt () {
      return `${this.failedCount}个文件上传失败，`
    },
    backRightNowPrompt () {
      return `立即返回(${this.backTime}S)`
    },
    maxCountPrompt () {
      return `不超过${this.uploadFileMax}个文件`
    },
    inUploading () {
      return (this.completedCount + this.failedCount) < this.items.length
    },
    finishWithErrors () {
      let finish = (this.completedCount + this.failedCount) === this.items.length
      return finish && this.failedCount > 0
    },
    finishWithSuccess () {
      let finish = (this.completedCount + this.failedCount) === this.items.length
      return finish && this.failedCount === 0
    }
  },
  watch: {
    uploadFiles (files, oldFiles) {
      if (files === oldFiles) return
      const uploadItems = {}
      const uuid = guid()
      for (let id in files) {
        const item = files[id]
        item.uuid = uuid
        normalizeUploadFile(item, id)
        uploadItems[item.typed_id] = item
      }
      this.items.unshift(...Object.keys(uploadItems).map(id => uploadItems[id]))
    },
    completedCount (newValue, oldVlaue) {
      this.handleBackTimerIfNeeded()
    },
    failedCount (newValue, oldVlaue) {
      this.handleBackTimerIfNeeded()
    }
  },
  methods: {
    onScroll () {
    },
    onItemUploaded (uploadedItem, upload_id) { // 上传成功
      this.items = this.items.map(item => {
        if (item.typed_id === upload_id) {
          return uploadedItem
        }
        return item
      })
      this.completedCount++
    },
    onItemDeleted (typed_id) {
      this.items = this.items.filter(item => {
        if (item.typed_id !== typed_id) {
          return true
        }
      })
    },
    onItemError () { // 上传失败
      this.failedCount++
    },
    onItemReUpload () {
      this.failedCount--
    },
    selectLocalFiles () { // 选择文件的action
      triggerUploadFile((files) => {
        let fileKeys = Object.keys(files)
        let end = fileKeys.length > this.uploadFileMax ? this.uploadFileMax : fileKeys.length
        let aMap = {}
        let validKeys = fileKeys.slice(0, end)
        validKeys.map(key => {
          aMap[key] = files[key]
          return key
        })
        this.uploadFiles = aMap
      }, this.uploadTarget)
    },
    retryAllErrors () {
      this.$bus.$emit('on-reUpload')
    },
    handleClose (e, closeVerion) {
      if (this.items.length > 0 && this.completedCount < this.items.length) {
        Dialog.alert({
          title: '确定结束本次上传吗？',
          message: '未成功上传的文件不会被保留',
          lockScroll: true,
          messageAlign: 'center',
          confirmButtonText: '结束上传',
          cancelButtonText: '下次再说',
          showConfirmButton: true,
          showCancelButton: true
        }).then((action) => {
          openPlatformCallback('fileUpload', this.normalizeCompletedFiles())
        }).catch(_ => {})
      } else {
        openPlatformCallback('fileUpload', this.normalizeCompletedFiles())
      }
    },
    normalizeCompletedFiles () {
      let res = this.items.map(item => {
        return normalizeUploadFile4back(item)
      })
      console.log('normalizeUploadFile4back: ')
      console.log(res)
      return res
    },
    shouldStartBackTimer () {
      if (this.completedCount === this.items.length) {
        return true
      }
      return false
    },
    handleBackTimerIfNeeded () {
      if (!this.shouldStartBackTimer()) return
      if (this.items.length > 0 && !this.closeTimer) {
        this.backTime = 3
        let self = this
        this.closeTimer = setInterval(_ => {
          self.backTime--
          if (self.backTime === 0) {
            self.closeTimer && clearInterval(self.closeTimer)
            self.handleClose()
          }
        }, 1000)
      }
    }
  }
}
</script>

<style lang="postcss">
@import "variables";
.select-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: center;
  color: #6ca2ff;
  & .upload-max-count {
    font-size: 14px;
    color: var(--secondlyText);
    margin-top: 4px;
  }
  & i {
    margin-bottom: 21px;
    font-size:100px;
    line-height: 100px;
    object-fit: contain;
  }
}

.upload-content {
  height: calc(100% - 44px);
  display: flex;
  flex-direction: column;
  background-color: var(--pageBgColor);
  & .bottom-actions {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 49px;
    box-shadow: 0 -1px 0 0 rgba(191, 191, 191, 0.5);
    background-color: #ffffff;
    & .state-icon {
      width: 22px;
      height: 22px;
      margin-right: 6px;
    }
    & .bottom-prompt {
      font-family: PingFangSC;
      font-size: 14px;
    }
  }
}

.file-list-container {
  height: calc(100% - 50px);
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
}

.file-list {
  overflow: auto;
  flex: 1 1 auto;
  // -webkit-overflow-scrolling: touch;

  & li {
    &:last-of-type {

      & .has-border-bottom {
        border: 0
      }
    }
  }

  & .file-item {
    position: relative;
    display: flex;
    min-height: 60px;
    background-color: #fff;
  }

  & .file-item.clickable:active {
    background: #fff;
  }

  & .upload-item {
    & .item-name {
      display: flex;
      margin-bottom: 0;
    }
  }

  & .item-action {
    z-index: 1;
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    width: 32px;
    padding-left: 0px;

    & .iconfont {
      color: var(--contentIcon);
      font-size: 22px;
    }

    & .icon-close-small {
      width: 12px;
      height: 12px;
      padding: 4px;
      border-radius: 50%;
      background-color: var(--contentIcon);
      color: #fff;
      font-size: 12px;
    }

    & .icon-arrow-next {
      font-size: 18px;
    }
  }

  & .waiting-info {
    color: var(--secondlyText);
    font-size: 12px;
  }

  & .error-info {
    color: var(--dangerColor);
    font-size: 12px;

    & .type-icon {
      margin-right: 5px;
    }

  }

  & progress {
    border: 0;
    height: 2px;
    width: 100%;
    margin-bottom: 10px;
    background: var(--progressBarBackground);
    color: var(--progressBarBase);

    &::-webkit-progress-bar {
      background: var(--progressBarBackground);
    }

    &::-webkit-progress-value {
      background: var(--progressBarBase);
    }
    &::-moz-progress-bar {
      background: var(--progressBarBase);
    }
  }

  & .item-main {
    flex: 1 1 auto;
    overflow: hidden;
    box-sizing: border-box;
    min-height: 60px;
    padding: 10px 10px 10px 0;
    text-align: left;

    & .item-name {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 3px;

      & .name {
        flex: 1 1 auto;
        width: 0;
      }

      & .loaded {
        color: var(--secondlyText);
        flex: 0 0 auto;
        font-size: 12px;
      }
    }

    & .item-meta {
      color: var(--secondlyText);
      font-size: 12px;
      line-height: 16px;

      & .icon-file-encrypt {
        color: var(--contentIcon);
        font-size: 12px;
        margin-right: 3px;
        /* vertical-align: -2px; */
      }
    }

    & .match-content {
      line-height: 20px;
      max-height: 60px;

      &.content {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
      }
    }

    & .tag-content {
      line-height: 18px;
      margin-top: 8px;
    }

    & .tag {
      display: inline-block;
      vertical-align: middle;
      box-sizing: border-box;
      padding: 0 6px;
      margin-right: 6px;
      max-width: 100px;
      border-radius: 2px;
      border: 1px solid #d1d4df;
      color: #4e5660;
      font-size: 12px;
    }

    & .tag-num {
      display: inline-block;
      font-size: 12px;
    }

    & .hit-num {
      background-color: #fff9a9;
    }
  }
}
</style>
